import axios from 'axios';

// we will define a bunch of API calls here.
const apiUrl = `${process.env.REACT_APP_API_URI}/profiles`;
const dsUrl = process.env.REACT_APP_DS_API_URI;

const getAuthHeader = async authState => {
  const token = await authState.getAccessTokenSilently();
  const { isAuthenticated } = authState;
  if (!isAuthenticated) {
    throw new Error('Not authenticated');
  }
  return { Authorization: `Bearer ${token}` };
};

const getDSData = (path, authState) => {
  // here's another way you can compose together your API calls.
  // Note the use of GetAuthHeader here is a little different than in the getProfileData call.
  const headers = getAuthHeader(authState);

  if (!path) {
    throw new Error('no path');
  }

  return axios
    .post(dsUrl + path, { headers })
    .then(res => {
      return res.data;
    })
    .catch(err => err);
};

const addTagDS = (path, body) => {
  if (!path) {
    throw new Error('no path');
  }

  return axios
    .post(dsUrl + path, body)
    .then(res => {
      return res.data;
    })
    .catch(err => err);
};

const deleteTagDS = (path, body) => {
  if (!path) {
    throw new Error('no path');
  }

  return axios
    .delete(dsUrl + path + '?' + body)
    .then(res => {
      return res.data;
    })
    .catch(err => err);
};

const apiAuthGet = authHeader => {
  return axios.get(apiUrl, { headers: authHeader });
};

const getProfileData = authState => {
  try {
    return apiAuthGet(getAuthHeader(authState)).then(response => response.data);
  } catch (error) {
    return new Promise(() => {
      return [];
    });
  }
};

const axiosWithAuth = async authState => {
  const headers = await getAuthHeader(authState);

  return axios.create({ headers });
};

export { getProfileData, getDSData, addTagDS, deleteTagDS, axiosWithAuth };
